export async function checkLoginStatus() {
  if (location.host.indexOf('kub.app.builderall.io') > 0) {
    return {
      isLogged: true,
      email: 'hullypastoriopereira@gmail.com'
    }
  }
  try {
      const url = `${process.env.OFFICE}/us/office/login-status`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'include'
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error)
      return false;
    }
}